export default {
    methods: {
        formatDate(data) {
            if (!data) return
            let dataBr = data.split("T")[0];
            let dataFormatada = dataBr.split("-").reverse().join("/");
            return dataFormatada;
        },
        formatDateTime(data) {
            if (!data) return
            let dataBr = data.split("T")[0];
            let timeBr = data.split("T")[1].substring(0, 8);
            let dataFormatada = dataBr.split("-").reverse().join("/");
            return dataFormatada + ' ' + timeBr;
        },
    }
}
